module.exports = __webpack_public_path__ + "static/media/PlayfairDisplay-ExtraBold.6dfe95e4.woff";